export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_11.b1118f81.jpg";